import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getAccounting } from './accounting.selectors';

const selectDealers = createSelector(getAccounting, ({ dealers }) => dealers);

const selectDealersValues = createSelector(selectDealers, Object.values);

export const selectDealersOptions = createSelector(selectDealersValues, dealers =>
  dealers.map(dealer => ({ value: dealer.id, name: dealer.name })),
);

export const selectFilteredDealers = createSelector(
  getDebouncedSearchValue,
  selectDealersValues,
  searchItems(dealer => [dealer.name]),
);
